import { render, staticRenderFns } from "./AppointmentAddress.vue?vue&type=template&id=1ebb4346&scoped=true"
import script from "./AppointmentAddress.vue?vue&type=script&lang=js"
export * from "./AppointmentAddress.vue?vue&type=script&lang=js"
import style0 from "./AppointmentAddress.vue?vue&type=style&index=0&id=1ebb4346&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebb4346",
  null
  
)

export default component.exports